import $axios from '@/core/api.service'
import i18n from '../i18n'

class AuthService {
  // authenticate user
  getToken ({ email, password, rememberMe }) {
    const locale = i18n.global.locale.value
    return $axios.post('/api/login', { email, password, locale, remember_me: rememberMe })
  }

  // update password
  updatePassword ({ currentPassword, newPassword, confirmPassword }) {
    return $axios.post('/api/users', {
      current_password: currentPassword,
      password: newPassword,
      password_confirmation: confirmPassword
    })
  }

  sendEmail (email, locale) {
    return $axios.post('/api/users/reset-password', { email, locale })
  }

  resetPassword (email, token, password, confirmPassword, locale) {
    return $axios.post('/api/users/reset', {
      email,
      token,
      password,
      locale,
      password_confirmation: confirmPassword
    })
  }

  verify2FA (secret, accessToken) {
    return $axios.post('/api/verify2fa', { secret }, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        Accept: 'application/json'
      }
    })
  }

  toggle2FA (toggle) {
    return $axios.post('/api/users/toggle2fa', {
      enable: toggle
    })
  }
}

export default new AuthService()
